define('bindingHandlers/autoFocus',['lib/knockout', 'jquery', 'lib/lodash4'], function (ko, $, _) {
    'use strict';

    /**
     * <p>Binding for autoFocusing an input when a property becomes true</p>
     * <p>
     * This binding focuses an input when the boolean observable becomes true.
     * Nothing will occur when the boolean becomes false.
     * </p>
     * @exports bindingHandlers/autoFocus
     */
    ko.bindingHandlers.autoFocus = {
        update: function (element, valueAccessor) {
            var $element = $(element),
                bindingData = valueAccessor();

            if (_.isUndefined(bindingData)) {
                $element.attr('autofocus', 'autofocus');
            } else {
                var shouldFocus = ko.utils.unwrapObservable(bindingData);
                if(shouldFocus) {
                    $element.focus();
                }
            }
        }
    };
});

